module.exports = __webpack_public_path__ + "img/about-辅导项目-初级职称（师）类.bead0e75.jpg";